module.exports = __webpack_public_path__ + "static/media/trees.dfa26224.png";